import { checkHttpStatus, getBaseUrl, getApiHeaders } from '../utils'

export const UNLOCK_ACCOUNT_REQUEST = 'UNLOCK_ACCOUNT_REQUEST'
export const UNLOCK_ACCOUNT_SUCCESS = 'UNLOCK_ACCOUNT_SUCCESS'
export const UNLOCK_ACCOUNT_FAILURE = 'UNLOCK_ACCOUNT_FAILURE'

export function unlockAccountSuccess() {
  return {
    type: UNLOCK_ACCOUNT_SUCCESS
  }
}

export function unlockAccountFailure() {
  return {
    type: UNLOCK_ACCOUNT_FAILURE
  }
}

export function unlockAccountRequest() {
  return {
    type: UNLOCK_ACCOUNT_REQUEST
  }
}

export function unlockAccount(token) {
  return async (dispatch, getState) => {
    const state = getState()
    const url = `${getBaseUrl()}/quest_maker/api/unlock_accounts/${token}`
    dispatch(unlockAccountRequest())
    try {
      checkHttpStatus(
        await fetch(url, {
          method: 'PUT',
          headers: getApiHeaders(state)
        })
      )

      dispatch(unlockAccountSuccess())
    } catch (error) {
      dispatch(unlockAccountFailure(error))
    }
  }
}



// WEBPACK FOOTER //
// ./src/actions/unlockaccount.js